import React from "react";
import game1 from './images/wordSearch.jpg';
import game2 from './images/clarityIsPower.jpg';
import game3 from './images/puzzle.jpg';
import game4 from './images/CupAndSaucer.jpg';
import game5 from './images/lookForObjectsInDark.jpg';
import game6 from './images/cakeMaking.jpg';
import landingPage from './images/LandingPage.jpg';
import game7 from './images/coloring1.jpg';
import game8 from './images/coloring2.jpg';
import game9 from './images/partsofmybody.jpg'
import chatApp from './images/ChatApp.jpg';
import valluva from './images/valluva.jpg';
import konva from './images/konva.png'
import imageofachild from './images/imageofachild.jpg'
import './Work.css';
import { Button, Icon } from "semantic-ui-react";

function Work() {
    const handleIframeClick = (url) => {
        window.open(url, "_blank");
    };

    const games = [
        { id: 1, name: "wordSearch", imageUrl: game1 , url: "https://gamingcanvas.s3.ap-south-1.amazonaws.com/wordSearch.html" },
        { id: 2, name: "Clarity is Power", imageUrl: game2 , url: "https://gamingcanvas.s3.ap-south-1.amazonaws.com/I%E2%80%99m+aware+that+clarity+is+power.html" },
        { id: 3, name: "eyePuzzle", imageUrl: game3 , url: "https://gamingcanvas.s3.ap-south-1.amazonaws.com/eyePuzzle.html" },
        { id: 4, name: "Cup And Saucer", imageUrl: game4 , url: "https://gamingcanvas.s3.ap-south-1.amazonaws.com/CupAndSaucer.html" },
        { id: 5, name: "Look for Objects in the Dark", imageUrl: game5 , url: "https://gamingcanvas.s3.ap-south-1.amazonaws.com/Can+you+look+for+the+objects+in+the+dark.html" },
        { id: 6, name: "Cake Making", imageUrl: game6 , url: "https://gamingcanvas.s3.ap-south-1.amazonaws.com/cakeMaking.html" },
        { id: 7, name: "Coloring Game", imageUrl: game7 , url: "https://gamingcanvas.s3.ap-south-1.amazonaws.com/coloring.html" },
        { id: 8, name: "Color Me Happy", imageUrl: game8 , url: "https://gamingcanvas.s3.ap-south-1.amazonaws.com/coloring2.html" },
        { id: 9, name: "Parts Of My Body", imageUrl: game9 , url: "https://gamingcanvas.s3.ap-south-1.amazonaws.com/PartsOfMyBody.html" },
    ];

    return (
        <div className="portfolio">
        <div className="title1">
            <h1>My Works</h1>
        </div>

        <div className='About'>
                <h1 className='landingPage'>Landing Page.</h1>
                <div className='line'></div>
        </div>

        <div className="LandingPageWrapper">
            <div className="Pages">
                <img className="page1" src={landingPage} alt="" />
                <h3 className="projectName">Image of a Child</h3>
                <div className="skillIcon">
                    <Icon name="react" className="reactLogo" size="big" />
                </div>
                <Button onClick={() => handleIframeClick('https://imageofachild.ai/hiring')}>Vist</Button>
            </div>

        </div>

        <div className='About'>
                <h1 className='landingPage'>Web Application.</h1>
                <div className='line'></div>
        </div>

        <div className="LandingPageWrapper">
            <div className="Pages">
                <img className="page1" src={imageofachild} alt="" />
                <h3 className="projectName">Image of a Child</h3>
                <div className="skillIcon">
                    <Icon name="react" className="reactLogo" size="big" />
                </div>
                <Button onClick={() => handleIframeClick('https://imageofachild.ai/home')}>Vist</Button>
            </div>

            <div className="Pages">
                <img className="page1" src={chatApp} alt="" />
                <h3 className="projectName">Chat Application</h3>
                <div className="skillIcon">
                    <Icon name="react" size="big" className="reactLogo" />
                    <Icon name="node js" color="green" size="big" />
                    <Icon name="aws" size="big" />
                </div>
                <Button onClick={() => handleIframeClick('https://main.d2dk62ibg80ea.amplifyapp.com/')}>Vist</Button>
            </div>

            <div className="Pages">
                <img className="page1" src={valluva} alt="" />
                <h3 className="projectName">Valluva</h3>
                <div className="skillIcon">
                    <Icon name="react" size="big" className="reactLogo" />
                </div>
                <Button onClick={() => handleIframeClick('https://main.d1p7ocdpdiwzdu.amplifyapp.com/chat')}>Vist</Button>
            </div>

        </div>

        <div className='About'>
                <h1 className='landingPage'>2D Annimated Games.</h1>
                <div className='line'></div>
        </div>

        <div className="LandingPageWrapper">
           {
            games.map((game) => (
                <div className="Pages">
                    <img key={game.id} className="page1" src={game.imageUrl} alt={game.name} />
                    <h3 className="projectName">{game.name}</h3>
                    <div className="skillIcon">
                        <img  className="konvaLogo" src={konva} alt="" />
                    </div>
                    <Button onClick={() => handleIframeClick(game.url)}>Play</Button>
                </div>
            ))
           }
        </div>
        </div>
    );
}

export default Work;
